module.exports = "<ubi-shell [options]=\"options\" [appTitle]=\"'Avemov'\" [user]='user'>\r\n\r\n    <div shell-copyright>\r\n        <!-- &copy; <a href=\"http://ubiquity.pt\" target=\"_blank\">Ubiquity</a> 2017 -->\r\n    </div>\r\n\r\n    <div shell-status>\r\n        <!-- Grupo ETE -->\r\n    </div>\r\n\r\n</ubi-shell>\r\n"


//////////////////
// WEBPACK FOOTER
// C:/Temp/Avemov/Avemov-Angular/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main